import { IOption } from "../../components/inputs/select-dropdown/select-dropdown";
import { IShippingConnection } from "../../models/IntegrationsTypes";
import { SHIPMENT_STATUS_ENUM } from "../manage-returns/rma-page/rma-types";

export enum ShippingInstructionsChangeTrigger {
    RETURN_METHODD_SET_CHANGES = 'RETURN_METHODD_SET_CHANGES',
    RETURN_METHODD_TYPE = 'RETURN_METHODD_TYPE',
    DROP_OFF_LOCATION = 'DROP_OFF_LOCATION',
    DROP_OFF_CONNECTION = 'DROP_OFF_CONNECTION',
    LABEL_TYPE = 'LABEL_TYPE',
    SHIPPING_CONNECTION = 'SHIPPING_CONNECTION',
}

export interface IReturnMethod {
    id: number,
    shipment_notification: SHIPMENT_NOTIFICATION,
    name: string,
    display_name: string,
    description: string,
    instruction: string,
    default_fee_type: number,
    type: RETURN_METHOD_TYPE,
    has_packing_slip: boolean,
    has_address_slip: boolean,
    shopify_restock_location_id: string,
    is_hidden: boolean,
    address?: null | IReturnMethodAddress,
    shopify_drop_off_location_id ?: string,
    drop_off_locator_url: string,
    return_label_setting?: IReturnLabelSettings,
    use_dynamic_address?: boolean,
    drop_off_setting?: IDropOffSettings,
    slip_barcode_id_type?: SLIP_BARCODE_TYPE,
    address_slip_barcode_id_type?: SLIP_BARCODE_TYPE
    create_return_in_wms: CREATE_RETURN_IN_INTEGRATION_TYPE,
    integrations_connections: IReturnMethodIntegrationConnection[],
    _internal_name: string,

    _has_changes?: boolean,
}

export enum SLIP_BARCODE_TYPE {
    ORDER_ID = "ORDER_ID",
    RETURNGO_RMA_ID = "RETURNGO_RMA_ID",
    WAREHOUSE_RMA_ID = "WAREHOUSE_RMA_ID",
}

export function slipBarCodeTypes(getTranslation: (key: string, scope: string) => string): IOption[] {
    return [
        { value: SLIP_BARCODE_TYPE.ORDER_ID, label: getTranslation('ORDER_ID', 'dashboard-return-method-editor') },
        { value: SLIP_BARCODE_TYPE.RETURNGO_RMA_ID, label: getTranslation('RETURNGO_RMA_ID', 'dashboard-return-method-editor') },
        { value: SLIP_BARCODE_TYPE.WAREHOUSE_RMA_ID, label: getTranslation('WAREHOUSE_RMA_ID', 'dashboard-return-method-editor') },
    ];
}

export interface IReturnLabelSettings {
    carrier_code: string,
    carrier_notifications: CARRIER_NOTIFICATION,
    cp_dimension_unit: CP_DIMENSION_UNIT|null,
    cp_height: null | number,
    cp_length: null | number,
    cp_width: null | number,
    id: number,
    label_format: null | string,
    label_size: null | string,
    label_type: LABEL_TYPE,
    package_code: string,
    return_method_id: number,
    send_order_number: boolean,
    service_code: string,
    shipping_connection_id: number,
    use_custom_package: boolean,
    use_forward_labels: boolean,
    weight: number|null,
    package_weight: number|null,
    weight_unit: WEIGHT_UNIT|null,
    is_signature_confirmation_required: boolean | null,
    shipping_connection?: IShippingConnection,
    ignore_address_validation?: boolean,
    is_box_free?: boolean,
    default_hs_code?: string,
    default_customer_company?: string,
    arrived_at_hub_to_internal_status: SHIPMENT_STATUS_ENUM | null;
    return_label_setting_carriers: IReturnLabelSettingCarrier[] | null,
    auto_selection_type: LABEL_SETTING_AUTO_SELECTION_TYPE | null,
    should_create_label_on_exchange_order?: boolean;
    dangerous_goods_type?: DANGEROUS_GOODS_TYPE | null;

    _deleted?: boolean,
    _has_changes?: boolean,
}

export enum LABEL_SETTING_AUTO_SELECTION_TYPE {
    BEST_VALUE = 'best_value',
    CHEAPEST = 'cheapest',
    FASTEST = 'fastest',
}

/** TODO: not sure if labels should be translatable or not */
export function returnLabelSettingAutoSelectionTypeOptions(): IOption[] {
    return [
        {
            value: LABEL_SETTING_AUTO_SELECTION_TYPE.BEST_VALUE,
            label: 'Auto select by best value'
        },
        {
            value: LABEL_SETTING_AUTO_SELECTION_TYPE.CHEAPEST,
            label: 'Auto select by cheapest'
        },
        {
            value: LABEL_SETTING_AUTO_SELECTION_TYPE.FASTEST,
            label: 'Auto select by fastest'
        },
    ]
}

export interface IReturnLabelSettingCarrier {
    id: number
    carrier_code: string
    carrier_name: string
    return_label_setting_id: number
    return_label_setting_services: IReturnLabelSettingService[]
    _deleted?: boolean,
    _has_changes?: boolean
}

export interface IReturnLabelSettingService {
    id: number
    service_code: string
    service_name: string
    return_label_setting_carrier_id: number
}

export interface ICarrierForSelectionDto {
    carrierCode: string,
    carrierName: string,
    list: ICarrierServiceForSelectionDto[]
}

export interface ICarrierServiceForSelectionDto {
    serviceCode: string,
    serviceName: string
}

export interface IShipmentOptionsForSelectionResponseDto {
    list: ICarrierForSelectionDto[]
}

export enum CP_DIMENSION_UNIT {
    CM = 'cm',
    IN = 'in',
}

export enum LABEL_TYPE {
    LABEL_TYPE_QR = 'LABEL_TYPE_QR',
    LABEL_TYPE_PRINTABLE = 'LABEL_TYPE_PRINTABLE',
    LABEL_TYPE_PRINTABLE_AND_QR = 'LABEL_TYPE_PRINTABLE_AND_QR',
}


export enum CARRIER_NOTIFICATION {
    USE_MERCHANT_EMAIL_AS_TO_EMAIL = 'USE_MERCHANT_EMAIL_AS_TO_EMAIL',
    USE_CUSTOMER_EMAIL_AS_TO_EMAIL = 'USE_CUSTOMER_EMAIL_AS_TO_EMAIL',
    DO_NOT_SEND_EMAIL_ADDRESS_TO_CARRIER = 'DO_NOT_SEND_EMAIL_ADDRESS_TO_CARRIER',
}

export enum WEIGHT_UNIT {
    GRAM = 'g',
    KILOGRAM = 'kg',
    OUNCE = 'oz',
    POUND = 'lb',
}

export enum RETURN_METHOD_CATEGORY {
    NO_SHIPMENT_REQUIRED = 'no_shipment_required',
    DROP_OFF_LOCATION = "drop_off_location",
    SHIP_WITH_ANY_CARRIER = 'ship_with_any_carrier',
    SHIP_WITH_PRE_PAID_LABEL = 'ship_with_pre_paid_label',
}

export enum SHIPMENT_NOTIFICATION {
    NONE_SHIPMENT_NOTIFICATION = 0,
    ON_ANY_UPDATE_SHIPMENT_NOTIFICATION = 1,
    ONLY_ON_TRANSIT_SHIPMENT_NOTIFICATION = 2,
    ONLY_ON_SHIPMENT_RECEIVED_NOTIFICATION = 3,
}

export interface IReturnMethodCategory {
    category: RETURN_METHOD_CATEGORY, list: IReturnMethod[],
};

export enum RETURN_METHOD_TYPE {
    NO_SHIPMENT_REQUIRED = 0,
    SHIP_WITH_ANY_CARRIER = 1,
    SHIP_WITH_PRE_PAID_LABEL = 2,
    DROP_OFF_LOCATION = 3,
}

export enum CREATE_RETURN_IN_INTEGRATION_TYPE {
    CREATE_RETURN_IN_INTEGRATION_NONE = 'none',
    CREATE_RETURN_IN_INTEGRATION_ALL = 'all',
    CREATE_RETURN_IN_INTEGRATION_BY_LIST = 'by_list',
}


export interface IAddressCategory {
    category: string,
    options: IOption[],
}

export interface IReturnMethodIntegrationConnection {
    id: number,
    return_method_id: number,
    integration_connection_id: number,

    _deleted?: boolean,
    _has_changes?: boolean,
}

export interface IInventoryTrackingConnection {
    id: number,
    internal_name: string,
}

export interface IPlatformLocation {
    name: null | string,
    country: string | null,
    country_code: string | null,
    formatted_address: string,
    fulfillsOnlineOrders: boolean,
    line_1: string | null,
    line_2: string | null,
    location_id: string,
    city: string | null,
    phone: string | null,
    postal_code: string | null,
    state: string | null,
    state_code: string | null,
}

export interface IReturnMethodAddress {
    id: number;
    shopify_location_id: null | string;
    return_method_id: number;
    setting_id: null | number;
    name: null | string,
    company: null | string,
    country: string | null,
    country_code: string | null,
    line_1: string | null,
    line_2: string | null,
    city: string | null,
    phone: string | null,
    postal_code: string | null,
    state: string | null,
    state_code: string | null,

    _deleted?: boolean,
    _has_changes?: boolean,
}

export interface ICarrier {
    name: string,
    code: string,
}

export interface IAggregatorInfo {
    label: string,
    value: string,
    selected: boolean,
    description:string,
    link: string,
    note: string,
    trackingNotSupportedNote?: string,
    trackingHelpLink?: string,
    capabilities: ICapability,
    labelSettings: IAggregatorLabelSettings,
    isDropOffIntegration: boolean,
    areInstructionsEditable:boolean,
    warningText?: string,
    logoIconUrl: string,
    isShipByReturnGo?: boolean, 
    isCoverage?: boolean,
}

interface IAggregatorLabelSettings {
    USE_CUSTOM_PACKAGE: CUSTOM_PACKAGE_SUPPORT_TYPE,
    SHOULD_SEND_ORDER_NUMBER: boolean,
    ADDRESS: IAggregatorAddressConfiguration,
    REQUIRE_SIGNATURE: boolean,
    IS_SINGLE_CARRIER: boolean,
    DEFAULT_WEIGHT_REQUIRED: boolean,
    DEFAULT_SIGNATURE_NOTE: string,
    IGNORE_ADDRESS_VALIDATION: boolean,
    DEFAULT_HS_CODE_REQUIRED: DEFAULT_HS_CODE_REQUIRED_TYPE,
    REQUIRE_EMAIL_ADDRESS_FOR_CARRIER: boolean,
    ARRIVED_AT_HUB_TO_INTERNAL_STATUS?: IArrivedAtHubToInternalStatusSettings;
    LABEL_SETTINGS_NOTE?: string;
    IS_CREATE_LABEL_ON_EXCHANGE_CONFIGURABLE?: boolean;
    DANGEROUS_GOODS?: boolean;
}

interface IAggregatorAddressConfiguration {
    configurable: boolean,
    reasonNote: string | null,
}

export interface ICapability {
    trackingType: TRACKING_TYPE,
    LABEL_COST: boolean,
    RATES: boolean,
    RETURN_LABELS: RETURN_LABELS_TYPE,
    DROP_OFF_LOCATION: boolean,
    IS_LOCATOR_URL_CONFIGURABLE: boolean,
    FORWARD_LABELS: boolean,
    LABEL_TYPE_SUPPORT: {[value in LABEL_TYPE as string]: boolean};
    DEFAULT_LABEL_TYPE: LABEL_TYPE,
    LABEL_TYPE_SUPPORT_NOTE: string | null,
    SUPPORT_MULTIPLE_SHIPMENTS_PER_RMA: boolean,
    BOX_FREE: BOX_FREE_TYPE,
    SUPPORT_CARRIER_SELECTION_OPTIONS: boolean
}

/** DEPRECATED, the enum was copied from old return methods
 * Currently we treat it as boolean, when the value is RETURN_LABELS_NEVER - treat as False and rest of values are True */
export enum RETURN_LABELS_TYPE {
    RETURN_LABELS_ALWAYS = 'Always',
    RETURN_LABELS_NEVER = 'Never',
    RETURN_LABELS_DEPENDS_ON_CARRIER = 'Depends on carrier',
}

export interface IDropOffSettings {
    id: number,
    shipping_connection_id: number,
    shipping_connection?: IShippingConnection,
    return_method_id: number,
    _deleted: boolean,
}

export enum TRACKING_TYPE {
    TRACKING_TYPE_AUTOMATIC = 'Automatic',
    TRACKING_TYPE_MANUAL_REGISTRATION = 'Manual registration',
    TRACKING_TYPE_NOT_SUPPORTED = 'Not supported',
}

export enum CUSTOM_PACKAGE_SUPPORT_TYPE {
    USE_CUSTOM_PACKAGE_ALWAYS = 'always',
    USE_CUSTOM_PACKAGE_NEVER = 'never',
    USE_CUSTOM_PACKAGE_OPTIONAL = 'optional',
}

export enum BOX_FREE_TYPE {
    ALWAYS = 'always',
    NEVER = 'never',
    OPTIONAL = 'optional',
}

export enum DEFAULT_HS_CODE_REQUIRED_TYPE {
    DEFAULT_HS_CODE_REQUIRED_ALWAYS = 'always',
    DEFAULT_HS_CODE_REQUIRED_NEVER = 'never',
    DEFAULT_HS_CODE_REQUIRED_OPTIONAL = 'optional',
}

export enum DANGEROUS_GOODS_TYPE {
    NOT_DANGEROUS = 'NOT_DANGEROUS',
    OTHER = 'OTHER',
    LITHIUM_BATTERIES = 'LITHIUM_BATTERIES',
    BIOLOGICAL_MATERIALS = 'BIOLOGICAL_MATERIALS',
}

export const DANGEROUS_GOODS_TYPE_TRANSLATION_KEYS_MAP = {
    [DANGEROUS_GOODS_TYPE.NOT_DANGEROUS]: 'DANGEROUS_GOODS_TYPE_NOT_DANGEROUS',
    [DANGEROUS_GOODS_TYPE.OTHER]: 'DANGEROUS_GOODS_TYPE_OTHER',
    [DANGEROUS_GOODS_TYPE.LITHIUM_BATTERIES]: 'DANGEROUS_GOODS_TYPE_LITHIUM_BATTERIES',
    [DANGEROUS_GOODS_TYPE.BIOLOGICAL_MATERIALS]: 'DANGEROUS_GOODS_TYPE_BIOLOGICAL_MATERIALS',
} as const;

export interface IArrivedAtHubToInternalStatusSettings {
    values: SHIPMENT_STATUS_ENUM[];
    default: SHIPMENT_STATUS_ENUM;
}
